var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegafono(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 124,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#megafono_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.362 90.875l.842 2.97 6.506 23.421 1.402 4.987c.505.224 1.066.392 1.571.561 9.087 2.857 17.388-1.962 17.388-1.962l-1.963-6.836-1.234-4.258-5.216-18.21-1.907-6.669-17.389 5.996z",
    fill: "#27FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.363 90.874l.841 2.97 18.454-2.185-1.907-6.668-17.388 5.883zM24.71 117.266l1.403 4.987c.505.224 1.066.392 1.57.561 7.517-.673 12.79-5.604 15.425-8.742l-1.234-4.258c-4.88 3.586-12.845 6.22-17.164 7.452z",
    fill: "#02F3A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.784.437s17.501 10.31 26.531 36.59c10.097 29.473 2.356 47.795 2.356 47.795s-19.351-10.926-28.83-33.9C75.304 27.95 84.783.438 84.783.438z",
    fill: "#086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.115 45.992c-1.794 6.78 0 12.159 5.89 15.913l29.616-10.926c1.963-6.78 0-12.103-5.89-15.914L67.117 45.992z",
    fill: "#00E187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.621 50.979c4.88-3.53.898-15.353-5.89-15.914 0 0-4.094 2.466-1.402 9.638 2.693 7.284 7.292 6.276 7.292 6.276z",
    fill: "#02AD76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.351 71.712c.056.168.112.336.112.448 2.805 9.693 13.182 15.017 22.773 11.879.112-.056.225-.056.337-.112 2.3-.729 4.88-1.513 7.684-2.242 2.3-.616 4.712-1.176 7.348-1.68 11.555-2.298 25.97-3.53 41.732-1.29 3.982.56 8.077 1.401 12.228 2.466 1.009.28 2.075.56 3.085.84 2.636.785 5.329 1.626 8.021 2.634C86.074 60.841 77.492 32.49 84.84.325a124.998 124.998 0 01-5.44 8.013c-.45.617-.898 1.177-1.347 1.737-15.2 19.5-34.272 30.706-48.519 36.814-2.3 1.008-4.487 1.849-6.506 2.578-.45.168-.954.336-1.403.504-8.806 3.306-13.742 12.72-11.274 21.74z",
    fill: "#27FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.493 35.179c1.065 9.806 3.702 18.659 7.796 26.28 4.207 7.9 9.984 14.568 17.276 19.835 1.01.28 2.076.56 3.085.84-19.407-12.663-25.465-32.443-27.092-47.067-1.234-11.43-.056-21.46.786-26.616-.45.617-.898 1.177-1.347 1.737-.841 5.603-1.626 14.737-.504 24.99z",
    fill: "#02AD76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.572 73.673c15.033-.785 27.373 4.986 27.71 5.099-15.762-2.298-30.178-1.009-41.733 1.288-.504.112-.953.168-1.458.28l-.673.169c-.224.056-.505.112-.73.168-.28.056-.56.112-.897.168h-.112c-.28.056-.505.112-.785.168-.954.224-1.851.448-2.749.672-2.804.729-5.384 1.457-7.684 2.242l-6.226-7.06s-7.012-16.642-4.32-27.289c2.02-.728 4.208-1.625 6.507-2.577.842 2.241 1.963 5.211 3.422 8.46 5.048 11.376 16.435 18.66 28.887 18.212.336.056.617.056.841 0z",
    fill: "#02F3A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.208 62.523L9.51 86.728c1.57 4.65 6.675 7.116 11.33 5.547l17.164-5.883a3.996 3.996 0 002.188-5.772c-5.497-9.525-9.143-20.228-10.882-32.107-.393-2.465-2.86-4.034-5.273-3.194L6.761 51.205C3.228 52.38.984 55.574.76 59.104c-.113 1.177.056 2.298.448 3.419z",
    fill: "#80FFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.208 62.522L9.51 86.728c1.57 4.65 6.675 7.116 11.33 5.547l17.164-5.884a3.996 3.996 0 002.188-5.77s-12.565 8.18-23.727 4.93C7.94 83.086.76 59.103.76 59.103c-.113 1.177.056 2.298.448 3.419z",
    fill: "#27FFBD"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.779,
    height: 2.472,
    rx: 1.236,
    transform: "matrix(.80792 -.589 .34796 .93757 113.73 17.723)",
    fill: "#27FFBD"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.979,
    height: 2.473,
    rx: 1.236,
    transform: "rotate(-13.986 202.995 -463.555) skewX(.028)",
    fill: "#27FFBD"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 26.779,
    height: 2.469,
    rx: 1.235,
    transform: "matrix(.9902 .14087 .13366 .99097 123.044 52.86)",
    fill: "#27FFBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "megafono_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 157.5 0)",
    d: "M0 0h157v124H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/megafono.eb332909.svg";
export { SvgMegafono as ReactComponent };